import { render, staticRenderFns } from "./DeletePermissionMessage.vue?vue&type=template&id=08730ef6&"
import script from "./DeletePermissionMessage.vue?vue&type=script&lang=js&"
export * from "./DeletePermissionMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports